import {Utils} from "./Utils";

Utils.executeWhenDocumentIsReady( () => {
    let mainMenuWrapper: HTMLElement = document.querySelector('[data-mainmenu-wrapper]'),
        mainMenuTrigger: NodeListOf<HTMLElement> = document.querySelectorAll('[data-mainmenu-trigger]'),
        currentMainMenuTrigger: HTMLElement = document.querySelector('[data-mainmenu-trigger].is-current'),
        subMenuNavWrapper: NodeListOf<HTMLElement> = document.querySelectorAll('[data-submenu-column-wrapper]'),
        subMenuColumnsWrap: HTMLElement = document.querySelector('[data-submenu-columns-wrapper]'),
        subMenuWrap: HTMLElement = document.querySelector('[data-submenu-wrapper]'),
        subMenuTrigger: NodeListOf<HTMLElement> = document.querySelectorAll('[data-submenu-trigger]'),
        subMenuNavs: NodeListOf<HTMLElement> = document.querySelectorAll('[data-submenu-nav]'),
        closeButton: HTMLButtonElement = document.querySelector('[data-submenu-close]'),
        pageOverlay: HTMLElement = document.querySelector('.o-page__overlay'),
        sectionMenu: HTMLElement = document.querySelector('.c-section-menu');

    const activeClass: string = 'is-active',
          currentClass: string = 'is-current', // never add or remove, only used to identify current links
          pageOverlayActiveClass: string = 'o-page__overlay--for-mainmenu';

    mainMenuTrigger.forEach(function (trigger: HTMLButtonElement) {
        trigger.addEventListener('click', function () {
            let targetSubMenuContentId: number = parseInt(trigger.dataset.mainmenuTrigger);

            setPageOverlay(true);

            mainMenuTrigger.forEach(function (trigger: HTMLButtonElement) {
                trigger.classList.remove(activeClass);
            });

            if (!trigger.classList.contains(currentClass) && targetSubMenuContentId > 0) {
                trigger.classList.add(activeClass);
                if (trigger.tagName === 'BUTTON') {
                    openSubMenu(targetSubMenuContentId);
                }
            } else {
                trigger.classList.add(activeClass);
                if (trigger.tagName === 'BUTTON') {
                    openSubMenu(null);
                }
            }
        });
    });

    subMenuTrigger.forEach(function (trigger: HTMLButtonElement) {
        trigger.addEventListener('click', function () {
            openSubMenu(parseInt(trigger.dataset.submenuTrigger), trigger);
        });
    });

    closeButton.addEventListener('click', function () { closeMenu(); });
    pageOverlay.addEventListener('click', function () { closeMenu(); });

    function openSubMenu(targetSubMenuContentId: null | number, trigger: HTMLButtonElement = null) {
        subMenuWrap.classList.add(activeClass);

        // 1st-level menu button that is the current page.
        if (targetSubMenuContentId === null) {
            resetActiveStateOfSubMenuTrigger();

            subMenuNavs.forEach(function (subMenuNav) {
                if (subMenuNav.classList.contains(currentClass)) {
                    subMenuNav.classList.add(activeClass);
                    setHeightOfSubMenuColumnsWrap(subMenuNav);
                } else {
                    subMenuNav.classList.remove(activeClass);
                }
            });
        }
        // 2nd - 4th-level menu button. Open the target column and pre-set all buttons in the trigger-column.
        else if (trigger) {
            let parentNavOfTrigger: HTMLElement = trigger.closest('nav');

            if (!parentNavOfTrigger) {
                return;
            }

            let triggerSubMenuColumnNumber: number = parseInt(parentNavOfTrigger.dataset.submenuColumn),
                allTriggerOfParentNav: NodeListOf<HTMLElement> = parentNavOfTrigger.querySelectorAll('[data-submenu-trigger]');

            allTriggerOfParentNav.forEach(function (submenuTrigger: HTMLElement) {
                submenuTrigger.classList.remove(activeClass);
            });

            setHeightOfSubMenuColumnsWrap(parentNavOfTrigger);
            trigger.classList.add(activeClass);

            subMenuNavs.forEach(function (subMenu: HTMLElement) {
                let subMenuColumnNumber: number = parseInt(subMenu.dataset.submenuColumn);

                if (subMenuColumnNumber > triggerSubMenuColumnNumber) {
                    let targetSubNav: HTMLElement | null = document.querySelector(`[data-submenu-nav='${targetSubMenuContentId}']`);

                    if (targetSubNav) {
                        subMenu.classList.remove(activeClass);
                        targetSubNav.classList.add(activeClass);
                        setHeightOfSubMenuColumnsWrap(targetSubNav)
                    } else {
                        return;
                    }
                }
            });
        }
        // 1st-level menu button that is NOT the current page.
        else {
            let targetSubNav: HTMLElement | null = document.querySelector(`[data-submenu-nav='${targetSubMenuContentId}']`);

            if (targetSubNav) {
                closeAllSubMenus();
                targetSubNav.classList.add(activeClass);
                setHeightOfSubMenuColumnsWrap(targetSubNav);
            } else {
                return;
            }
        }
    }

    function closeAllSubMenus() {
        subMenuNavs.forEach(function (subNav: HTMLElement) {
            subNav.classList.remove(activeClass);
        });

        setHeightOfSubMenuColumnsWrap(null, true)
        resetActiveStateOfSubMenuTrigger();
    }

    function closeMenu() {
        subMenuWrap.classList.remove(activeClass);
        mainMenuTrigger.forEach(function (trigger: HTMLButtonElement) { trigger.classList.remove(activeClass) });
        subMenuNavWrapper.forEach(function (subMenuNavWrap: HTMLElement) { subMenuNavWrap.classList.remove(activeClass) });

        if (currentMainMenuTrigger) {
            currentMainMenuTrigger.classList.add(activeClass);
        }

        closeAllSubMenus();
        setPageOverlay(false);
    }

    function resetActiveStateOfSubMenuTrigger() {
        subMenuTrigger.forEach(function (trigger: HTMLElement) {
            if (trigger.classList.contains(currentClass)) {
                trigger.classList.add(activeClass);
            } else {
                trigger.classList.remove(activeClass);
            }
        });
    }

    function setHeightOfSubMenuColumnsWrap(subMenu: HTMLElement = null, unsetHeight: boolean = false) {
        if (unsetHeight) {
            subMenuColumnsWrap.style.height = '0px';
            return;
        }

        if (!subMenu) {
            return;
        }

        let activeSubmenuNavs = document.querySelectorAll('[data-submenu-nav].is-active'),
            heightToSet: number = 0;

        activeSubmenuNavs.forEach(activeSubmenuNav => {
            heightToSet = activeSubmenuNav.clientHeight > heightToSet ? activeSubmenuNav.clientHeight : heightToSet;
        });

        subMenuColumnsWrap.style.height = heightToSet < subMenu.clientHeight ? subMenu.clientHeight + 'px' : heightToSet + 'px';
    }

    function setPageOverlay(show: boolean) {
        if (!show && pageOverlay.classList.contains(pageOverlayActiveClass)) {
            pageOverlay.classList.remove(pageOverlayActiveClass);
            mainMenuWrapper.classList.remove(activeClass);

            if (sectionMenu) {
                sectionMenu.style.zIndex = '1030';
            }
            return;
        }

        if (show && !pageOverlay.classList.contains(pageOverlayActiveClass)) {
            pageOverlay.classList.add(pageOverlayActiveClass);
            mainMenuWrapper.classList.add(activeClass);

            if (sectionMenu) {
                sectionMenu.style.zIndex = '10';
            }
        }
    }

    const throttle = (callback: Function, delay: number) => {
        let wait = false;
        return function () {
            if (!wait) {
                callback();
                wait = true;
                setTimeout(function () {
                    wait = false;
                }, delay);
            }
        };
    };

    window.addEventListener('resize', throttle(() => {
        if (window.innerWidth < 1008) {
            closeMenu();
        }
    }, 200));
})